import React, {
  useMemo,
  useState
} from 'react';
import PropTypes from 'prop-types';
import {
  ArrowUp,
  Cross,
  MobileLogo
} from '../../assets';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';
import { StaticRoutes } from '../../Router';
import {
  MobileSidebar
} from '../../components';
import { useRecoilValue } from 'recoil';
import { applicationsList, userFirstName } from '../../recoil';
import { HamburgerIcon } from '../../assets';
import styles from './MobileHeader.module.css';

const MobileLeftSection = ({ onBackClick, shouldShowBackButton}) => {
  return shouldShowBackButton ?
    onBackClick
      ? <div
        className={styles.leftSectionBackIcon}
        onClick={onBackClick || undefined}
        onKeyDown={onBackClick || undefined}
        role='button'
        tabIndex='0'
      >
        <img src={ArrowUp} alt='back button' className={styles.backImage} />
      </div>
      : <div className={styles.leftSectionLogo}>
        <img className={styles.logoImage} src={MobileLogo} alt='Vodacom logo' />
      </div>
    : '';
};

MobileLeftSection.propTypes = {
  onBackClick: PropTypes.func,
  shouldShowBackButton: PropTypes.bool
};

const MobileRightSection = ({ onMenuClick }) => {
  const appList = useRecoilValue(applicationsList);
  const isPreSubmissionJourney = !Array.isArray(appList) || appList.length === 0;
  const navigate = useNavigate();
  const location = useLocation();
  const navigateTo = (path) =>
    navigate(path, {
      state: {
        returnPath: location.pathname
      }
    });
  return (
    <>
      { isPreSubmissionJourney ?
        <span className={styles.logoutLink} onClick={() => navigateTo(StaticRoutes.logout)} >LOGOUT</span>
        :
        <div className={styles.rightSection}>

          <img src={HamburgerIcon} alt="copy" onClick={onMenuClick} />

        </div>
      }
    </>
  );
};

MobileRightSection.propTypes = {
  onMenuClick: PropTypes.func
};

const MobileSideNav = ({ onCloseClick, setSideNavOpen }) => (
  <>
    <div className={styles.sideNavMobile}>
      <img
        src={Cross}
        alt="Close Icon"
        className={styles.closeImg}
        role='presentation'
        onClick={() => { onCloseClick?.(); }}
        onKeyDown={() => { onCloseClick?.(); }}
      />
      <MobileSidebar setSideNavOpen={setSideNavOpen} />
    </div>
    <div
      className={styles.backgroundBlurred}
      onClick={() => { onCloseClick?.(); }}
      onKeyDown={() => { onCloseClick?.(); }}
      role='presentation'
    />
  </>
);

MobileSideNav.propTypes = {
  onCloseClick: PropTypes.func,
  setSideNavOpen: PropTypes.func
};

export const MobileHeader = ({ children, onBackClick, shouldShowBackButton }) => {
  const [isSideNavOpen, setSideNavOpen] = useState(false);
  const name = useRecoilValue(userFirstName);

  const headerContainerStyle = useMemo(() => ({
    pointerEvents: isSideNavOpen ? 'none' : 'auto'
  }), [isSideNavOpen]);

  return isSideNavOpen ? (
    <MobileSideNav setSideNavOpen={setSideNavOpen} onCloseClick={() => setSideNavOpen(false)} />
  ) : (
    <div className={`${styles.headerContainer}`} style={headerContainerStyle}>
      <MobileLeftSection shouldShowBackButton={shouldShowBackButton} onBackClick={onBackClick} />

      {children}

      {name && <MobileRightSection onMenuClick={() => setSideNavOpen(true)}/>}
    </div>
  );
};

MobileHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onBackClick: PropTypes.func,
  shouldShowBackButton: PropTypes.bool
};
